import * as React from 'react'
import { createEffect, createStore } from 'effector'
import { useStore, useEvent } from 'effector-react'
import dayjs, { Dayjs } from 'dayjs'
import api from '../../Auth/api'
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers'
import {
  Paper,
  Box,
  TextField,
  Typography,
  Button,
  IconButton,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Table
} from '@mui/material'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { styled } from '@mui/material/styles'
import { set, useForm } from 'react-hook-form'
import { updateModal } from '../../components/ErrorModal'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { BlockTitle } from '../../components/UI/BlockTitle/BlockTitle'
import { Link } from 'react-router-dom'
const getSubstitutionsTableFx = createEffect(async (data) => {
  const response = api.post(`/replacements`, data)
  return response
})

const $substitutionsTable = createStore([])

$substitutionsTable.on(getSubstitutionsTableFx, (state) => {
  return {
    ...state
  }
})

$substitutionsTable.on(getSubstitutionsTableFx.done, (state, { result }) => {
  return {
    ...state,
    data: result.data.data
  }
})

$substitutionsTable.on(getSubstitutionsTableFx.fail, (state, { error }) => {
  return {
    ...state
  }
})

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0
  }
}))

export default function Replacements() {
  const deleteReplacement = createEffect(async (id) => {
    api
      .delete(`replacement`, {
        data: {
          id: id
        }
      })
      .then(
        () => getSubstitutionsTableFx(false),
        (error) => updateModal(error.response.data.errors)
      )
  })

  const [dateFrom, setDateFrom] = React.useState(dayjs()?.format('YYYY-MM-DD'))
  const [dateTo, setDateTo] = React.useState(
    dayjs().add(1, 'month')?.format('YYYY-MM-DD')
  )
  const SubstitutionsTable = useStore($substitutionsTable)
  const {} = useForm()
  const handleFormChange = () => {
    const from = dateFrom
    const to = dateTo
    const data = {
      datetimeRange: {
        min: from,
        max: to
      }
    }
    getSubstitutionsTableFx(data)
  }
  React.useEffect(() => {
    handleFormChange()
  }, [dateFrom, dateTo])
  React.useEffect(() => {
    getSubstitutionsTableFx(false)
  }, [])

  return (
    <>
      <Paper
        sx={{ padding: '1rem', borderRadius: '1rem', mt: 3 }}
        elevation={0}
      >
        <BlockTitle backUrl="/" label="Замещения" />
        <form>
          <Box display="flex" flexDirection="row" alignItems="center" mt={3}>
            <Typography pr={2} variant="subtitle2">
              Период действия:
            </Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                inputFormat="DD.MM.YYYY"
                label="От"
                value={dateFrom}
                onChange={(newValue) => {
                  setDateFrom(newValue?.format('YYYY-MM-DD'))
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
            <Typography pr={2} pl={2} variant="subtitle2">
              -
            </Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                inputFormat="DD.MM.YYYY"
                label="До"
                value={dateTo}
                onChange={(newValue) => {
                  setDateTo(newValue?.format('YYYY-MM-DD'))
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
          </Box>
        </form>
        <Link to="/new-replacement">
          <Button
            sx={{
              mt: '30px',
              height: 'fit-content',
              width: 'fit-content',
              backgroundColor: '#102C54'
            }}
            variant="contained"
            color="info"
          >
            Новое замещение
          </Button>
        </Link>
        <TableContainer
          component={Paper}
          sx={{
            marginTop: 3,
            maxWidth: 950,
            border: '1px solid #e6e6e6',
            boxShadow: 0
          }}
        >
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 600 }} align="center">
                  Дата от
                </TableCell>
                <TableCell sx={{ fontWeight: 600 }} align="center">
                  Дата до
                </TableCell>
                <TableCell sx={{ fontWeight: 600 }} align="center">
                  Кого замещает
                </TableCell>
                <TableCell sx={{ fontWeight: 600 }} align="center">
                  Кто замещает
                </TableCell>
                <TableCell sx={{ fontWeight: 600 }} align="center"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {SubstitutionsTable?.data &&
                SubstitutionsTable?.data?.map(
                  ({ id, startsAt, endsAt, user, replacer }) => (
                    <StyledTableRow
                      key={id}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell align="center">{startsAt}</TableCell>
                      <TableCell align="center">{endsAt}</TableCell>
                      <TableCell align="center">{user?.name}</TableCell>
                      <TableCell align="center">{replacer?.name}</TableCell>
                      <TableCell align="center">
                        <Button onClick={() => deleteReplacement(id)}>
                          Удалить
                        </Button>
                      </TableCell>
                    </StyledTableRow>
                  )
                )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </>
  )
}
